export const iconFontAwesomeFoodBeverageGlassWaterDroplet = (
	<i className="fa-solid fa-glass-water-droplet"></i>
);
